import { Injectable, OnDestroy } from '@angular/core';
import {
  ChangeEmailDomainStatus,
  DomainService as EmailDomainService,
  GetPendingEmailDomainResponseInterface,
  SenderType,
  VerifyPendingEmailDomainResponse,
} from '@vendasta/email';
import { SubscriptionList } from '@vendasta/rx-utils';
import { BehaviorSubject, Observable, Subject, of } from 'rxjs';
import { catchError, shareReplay, switchMap, tap } from 'rxjs/operators';
import { PartnerService } from '../../core/partner.service';

@Injectable()
export class PendingDomainService implements OnDestroy {
  private readonly subs = SubscriptionList.new();

  private load$$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  public pendingDomain$: Observable<GetPendingEmailDomainResponseInterface>;

  public readonly expectedRecords$: Observable<VerifyPendingEmailDomainResponse>;

  constructor(
    private readonly partnerService: PartnerService,
    private readonly api: EmailDomainService,
  ) {
    this.pendingDomain$ = this.load$$.pipe(
      switchMap(() =>
        this.api.getPendingEmailDomain(SenderType.SENDER_TYPE_PARTNER, this.partnerService.partnerId).pipe(
          catchError(() => {
            return of(null);
          }),
        ),
      ),
    );

    this.expectedRecords$ = this.pendingDomain$.pipe(
      switchMap(() => {
        // I have no idea why this is necessary. But it is.  -Brad
        const bs = new Subject<VerifyPendingEmailDomainResponse>();
        this.api
          .verifyPendingDomain(SenderType.SENDER_TYPE_PARTNER, this.partnerService.partnerId)
          .subscribe((v) => bs.next(v));
        return bs;
      }),
      shareReplay(1),
    );

    // Handle partner changes due to impersonation
    this.subs.add(this.partnerService.getPartnerId(), () => this.refresh());
  }

  public refresh(): void {
    this.load$$.next(true);
  }

  public requestEmailDomainChange(pd: GetPendingEmailDomainResponseInterface): Observable<any> {
    return this.api.changeForPartner(pd.senderId, pd.sendFromDomain, pd.sendFromUsername).pipe(
      tap((status) => {
        if (status !== ChangeEmailDomainStatus.CHANGE_EMAIL_DOMAIN_STATUS_ACCEPTED) {
          throw new Error('Domain change not accepted');
        }
      }),
    );
  }

  ngOnDestroy(): void {
    this.subs.destroy();
  }
}
